import guestRouter from './guestRouter';

export default guestRouter;
